import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import Modal from "../../../../components/molecules/Modal";
import moment from 'moment';
import FilterComponents from './components';

const filterInitialState = {
    confirmedStartDate:null,
    confirmedEndDate:null,
    createdStartDate:null,
    createdEndDate:null,
    status:[],
    couriers:[],
    tags:[],
    filterSearch:null
};

const filterInitialOepn = {
    confirmedDate:false,
    createdDate:false,
    status:false,
    couriers:false,
    tags:false,
    filterSearch:false
};

const ModalFilter = props => {
    const [ modalName, setModalName ] = useState(false);
    const [ filterName, setFilterName ] = useState('');
    const [ filters, setFilters ] = useState(filterInitialState)
    const [ filterOpen, setFilterOpen ] = useState(filterInitialOepn);

    const onSelectFilter = (newFilter) => {
        setFilterOpen({
            ...filterOpen,
            couriers:newFilter.couriers.length > 0 ? true : false,
            confirmedDate:newFilter.confirmedStartDate ? true : false,
            createdDate:newFilter.createdStartDate ? true : false,
            status:newFilter.status.length > 0 ? true : false,
            tags:newFilter.tags.length > 0 ? true : false,
        });
        setFilters({
            ...filters,
            couriers:newFilter.couriers || filters.couriers,
            confirmedEndDate:newFilter.confirmedEndDate || filters.confirmedEndDate,
            confirmedStartDate:newFilter.confirmedStartDate || filters.confirmedStartDate,
            courierServices:newFilter.courierServices || filters.courierServices,
            createdEndDate:newFilter.createdEndDate || filters.createdEndDate,
            createdStartDate:newFilter.createdStartDate || filters.createdStartDate,
            name:newFilter.name || filters.name,
            status:newFilter.status || filters.status,
            tags:newFilter.tags || filters.tags,
        })
    }

    const onChangeFilter = (key,value) => {
        setFilters({...filters, [key]:value})
    }

    const onChangeDate = (key, value) => {
        if (key === 'createdDate') {
            if (!value) { setFilters({...filters, createdStartDate:null, createdEndDate:null }); return };
            setFilters({...filters,
                createdStartDate:moment(value.from).format("YYYY-MM-DD"),
                createdEndDate:moment(value.to).format("YYYY-MM-DD"),
            })
        } else {
            if (!value) { setFilters({...filters, confirmedStartDate:null, confirmedEndDate:null }); return };
            setFilters({...filters,
                confirmedStartDate:moment(value.from).format("YYYY-MM-DD"),
                confirmedEndDate:moment(value.to).format("YYYY-MM-DD"),
            })
        }
    }

    const onHide = () => {
        props.onHide();
        setTimeout(() => {
            setModalName(false);
        }, 1000);
    }

    const onSubmitFilters = () => {
        props.onSubmitFilters(filterName,filters);
        props.onHide()
        setTimeout(() => {
            setModalName(false);
            setFilterName('');
            setFilterOpen(filterInitialOepn);
        }, 1000);
    }

    const onPreviewFilter = () => {
        props.onPreviewFilter(filters);
        props.onHide();
        setFilterOpen(filterInitialOepn);
    }

    const onClickOpen = name => {
        setFilterOpen({ ...filterOpen, [name]:!filterOpen[name] })
    }

    const onClickClose = name => {
        setFilterOpen({ ...filterOpen, [name]:!filterOpen[name] });
        if (name === 'createdDate') {
            setFilters({ ...filters, createdEndDate:null, createdStartDate:null})
        } else if (name === 'confirmedDate') {
            setFilters({ ...filters, confirmedEndDate:null, confirmedStartDate:null})
        } else {
            setFilters({ ...filters, [name]:filterInitialState[name]})
        }
    }

    return (
        <Modal
            show={props.show}
            onHide={onHide}
            title={"Filter"}
            size={"md"}
            bodyClassName="p-0"
            type={modalName ? "oneButton" : "yesno"}
            bText={"Simpan Filter"}
            bClick={onSubmitFilters}
            lbText="Tampilkan"
            lbClick={onPreviewFilter}
            rbText="Simpan Filter"
            rbClick={() => setModalName(true)}
            footerStyle={modalName ? null : {borderTop:0}}
            footerClassName="justify-content-end"
            buttons={true}
        >
            {
                modalName ? 
                    <div className="px-3 py-4">
                        <Form.Control
                            userId={props.userId}
                            value={filterName}
                            placeholder="Masukkan nama filter untuk disimpan"
                            onChange={e => setFilterName(e.target.value)}
                        />
                    </div> 
                    :
                    <div>
                        <FilterComponents.SavedFilter 
                            userId={props.userId}
                            onChange={e => onSelectFilter(e)}
                        />
                        <FilterComponents.CreatedDate 
                            startDate={filters.createdStartDate}
                            endDate={filters.createdEndDate}
                            open={filterOpen.createdDate}
                            onClickOpen={() => onClickOpen('createdDate')}
                            onClickClose={() => onClickClose('createdDate')}
                            onChange={e => onChangeDate("createdDate",e)}
                        />
                        <FilterComponents.ConfirmedDate 
                            startDate={filters.confirmedStartDate}
                            endDate={filters.confirmedEndDate}
                            open={filterOpen.confirmedDate}
                            onClickOpen={() => onClickOpen('confirmedDate')}
                            onClickClose={() => onClickClose('confirmedDate')}
                            onChange={e => onChangeDate("confirmedDate",e)}
                        />
                        <FilterComponents.Courier 
                            open={filterOpen.couriers}
                            value={filters.couriers}
                            onClickOpen={() => onClickOpen('couriers')}
                            onClickClose={() => onClickClose('couriers')}
                            onChange={e => onChangeFilter("couriers",e)}
                        />
                        <FilterComponents.Status 
                            open={filterOpen.status}
                            value={filters.status}
                            onClickOpen={() => onClickOpen('status')}
                            onClickClose={() => onClickClose('status')}
                            onChange={e => onChangeFilter("status",e)}
                        />
                        <FilterComponents.Tags 
                            userId={props.userId}
                            open={filterOpen.tags}
                            value={filters.tags}
                            onClickOpen={() => onClickOpen('tags')}
                            onClickClose={() => onClickClose('tags')}
                            onChange={e => onChangeFilter("tags",e)}
                        />
                    </div>
            }
                
        </Modal>
    )
};

export default ModalFilter